import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { action as toggleMenu } from 'redux-burger-menu';
import * as actions from 'actions';
import { bindActionCreators } from 'redux';
import { listheader as ListIcon, map as MapIcon } from 'common/svg/icons';
import { decorator as reduxBurgerMenu } from 'redux-burger-menu';
import {
  BurgerButton,
  Dropdown,
  IconList,
  InitialsBubble,
  Logo,
  MenuGreeting,
  NavigationBar,
  Responsive,
  Switcher,
  Online,
  NetworkStatus,
} from 'common/components';
import { TCModal, OnboardingDropdown } from 'containers';
import * as constants from 'common/constants';
import { isDesktop } from 'common/utils';

// mobile menu stuff
import { slide as Menu } from 'react-burger-menu';
const BurgerMenu = reduxBurgerMenu(Menu);

import './index.css';

class Header extends Component {
  static displayName = 'Header';
  static defaultProps = {
    storages: [],
  };

  state = {
    modal: false, // for TC modal
  };

  componentDidMount() {
    this.props.updateSeason(new Date().getFullYear()); // always display the current season
  }
  /**
   *
   *
   * @function toggleModal
   * @memberof Header
   * @public
   */
  toggleModal = () => {
    this.setState({ modal: !this.state.modal });
  };

  /**
   *
   *
   * @function increaseSeason
   * @memberof Header
   * @public
   */
  increaseSeason = () => {
    this.props.updateSeason(this.props.settings.season + 1);
  };

  /**
   *
   *
   * @function decreaseSeason
   * @memberof Header
   * @public
   */
  decreaseSeason = () => {
    this.props.updateSeason(this.props.settings.season - 1);
  };

  render() {
    const {
      auth,
      settings,
      fieldState,
      location,
      onLogout,
      toggleFieldView,
      toggleMenu,
    } = this.props;
    const navRight =
      location.pathname !== constants.ROUTE_FIELDS &&
      location.pathname !==
        constants.ROUTE_STORAGE ? null : fieldState.showMapFlag ? (
        <ListIcon className="agi-header-nav__right" onClick={toggleFieldView} />
      ) : (
        <Online>
          <MapIcon
            className="agi-header-nav__right"
            onClick={toggleFieldView}
          />
        </Online>
      );

    return (
      <Fragment>
        <Responsive.Mobile>
          <BurgerMenu
            bodyClassName="mobile-menu--is-open"
            className="slider-menu"
            width="78%"
          >
            <header className="slider-menu__header is-flex">
              <InitialsBubble
                userInfo={auth}
                className="slider-menu__initials"
              />
              <MenuGreeting name={auth.firstName} email={auth.email} />
            </header>
            <nav
              className="account-links is-flex"
              role="navigation"
              aria-label="account settings"
            >
              <ul className="account-links__list is-flex">
                <NetworkStatus
                  render={({ isOnline }) => {
                    const iconList = [
                      {
                        label: 'Help Centre',
                        icon: 'question',
                        href: 'https://agihelp.zendesk.com/hc/en-us',
                        action: () => {},
                      },
                      {
                        label: 'Terms & Conditions',
                        icon: 'document',
                        action: () => {
                          this.toggleModal();
                          toggleMenu();
                        },
                      },
                    ];

                    if (!isOnline) {
                      // remove the first element from array
                      iconList.shift();
                    }

                    return (
                      <IconList list={iconList} theme={['large', 'primary']} />
                    );
                  }}
                />
                <Online>
                  <li
                    className="account-links__logout margin--top-auto text--fade"
                    onClick={onLogout}
                  >
                    Logout
                  </li>
                </Online>
              </ul>
            </nav>
          </BurgerMenu>
        </Responsive.Mobile>

        <header className="agi-header-wrap">
          <div className="agi-header navbar is-fixed-top level">
            <Responsive.Desktop>
              <div className="agi-header-logo level-left">
                <Link to="/">
                  <Logo />
                </Link>
                <Dropdown
                  trigger={
                    <Switcher
                      title={settings.season}
                      leftAction={this.decreaseSeason}
                      rightAction={this.increaseSeason}
                      theme={['boxed']}
                    />
                  }
                  header={
                    <h2 className="text--header text--medium">
                      SWITCH SEASONS
                    </h2>
                  }
                  theme={['tight', 'season']}
                  triggerDisabled
                  isOpen={false}
                >
                  <div>
                    Switch between seasons to do crop planning for the future
                    seasons or update data for the past seasons.
                  </div>
                </Dropdown>
              </div>

              <div className="level-item agi-header-nav__container">
                <NavigationBar />
              </div>
              {isDesktop() && settings.features.showTutorials && (
                <OnboardingDropdown />
              )}
              <Dropdown
                className="level-right"
                header={
                  <MenuGreeting name={auth.firstName} email={auth.email} />
                }
                theme={['right', 'wide']}
                trigger={<InitialsBubble userInfo={auth} />}
              >
                <Fragment>
                  <IconList
                    list={[
                      {
                        label: 'Terms & Conditions',
                        icon: 'document',
                        action: this.toggleModal,
                      },
                    ]}
                    theme={['large', 'primary']}
                  />
                  <Online>
                    <a onClick={onLogout} className={'text--fade'}>
                      Logout
                    </a>
                  </Online>
                </Fragment>
              </Dropdown>
            </Responsive.Desktop>

            <Responsive.Mobile>
              <BurgerButton onClick={toggleMenu} />
              <div className="level-item">
                <NetworkStatus
                  render={({ isOnline }) => (
                    <Switcher
                      title={settings.season}
                      leftAction={this.decreaseSeason}
                      rightAction={this.increaseSeason}
                      theme={['invert']}
                      disabled={!isOnline}
                    />
                  )}
                />
              </div>
              {navRight}
            </Responsive.Mobile>
          </div>
        </header>

        {this.state.modal && <TCModal onToggle={this.toggleModal} />}
      </Fragment>
    );
  }
}

Header.propTypes = {
  auth: PropTypes.object,
  fieldState: PropTypes.object.isRequired,
  location: PropTypes.object,
  onLogout: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
  toggleFieldView: PropTypes.func.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  updateSeason: PropTypes.func.isRequired,
};

const mapState = ({ auth, settings }) => ({ auth, settings });

const mapDispatch = dispatch => {
  return {
    toggleMenu: () =>
      dispatch((_, getState) => {
        const isOpen = getState().burgerMenu.isOpen;
        dispatch(toggleMenu(!isOpen));
      }),
    updateSeason: bindActionCreators(actions.settings.updateSeason, dispatch),
  };
};

export default connect(
  mapState,
  mapDispatch
)(Header);



// WEBPACK FOOTER //
// ./src/containers/Header/index.js